<div class="flex flex-row font-extrabold pb-2">
    Type of residence:*
</div>
<div *ngIf="!isScreenSmall">
    <mat-radio-group aria-label="Select an option" class="flex flex-row justify-between items-center">
        <mat-radio-button [color]="'primary'" [checked]="ResidenceType == 'FreeStanding'"
            (change)="residenceType($event)" value="FreeStanding">Freestanding
        </mat-radio-button>
        <mat-radio-button [color]="'primary'" [checked]="ResidenceType == 'Estate'" value="Estate"
            (change)="residenceType($event)">Estate/Complex</mat-radio-button>
        <mat-radio-button [color]="'primary'" [checked]="ResidenceType == 'Plot'" value="Plot"
            (change)="residenceType($event)">Plot</mat-radio-button>
        <mat-radio-button [color]="'primary'" [checked]="ResidenceType == 'Apartment'" value="Apartment"
            (change)="residenceType($event)">Apartment</mat-radio-button>
    </mat-radio-group>
</div>
<div *ngIf="isScreenSmall">
    <mat-radio-group aria-label="Select an option" class="flex flex-row justify-between items-center">
        <div class="flex flex-col">
            <mat-radio-button [color]="'primary'" [checked]="ResidenceType == 'FreeStanding'"
                (change)="residenceType($event)" value="FreeStanding">Freestanding
            </mat-radio-button>
            <mat-radio-button [color]="'primary'" [checked]="ResidenceType == 'Estate'" value="Estate"
                (change)="residenceType($event)">Estate/Complex</mat-radio-button>
        </div>
        <div class="flex flex-col">

            <mat-radio-button [color]="'primary'" [checked]="ResidenceType == 'Plot'" value="Plot"
                (change)="residenceType($event)">Plot</mat-radio-button>
            <mat-radio-button [color]="'primary'" [checked]="ResidenceType == 'Apartment'" value="Apartment"
                (change)="residenceType($event)">Apartment</mat-radio-button>
        </div>
    </mat-radio-group>
</div>

<hr class="my-5">

<div *ngIf="ResidenceType == 'FreeStanding' || ResidenceType == 'Apartment' ">
    <form [formGroup]="orderDeliveryDetailsForm" #orderDeliveryDetailsNgForm="ngForm">

        <!-- Street Number field -->
        <mat-form-field class="w-full">
            <mat-label>Street number</mat-label>
            <input id="DeliveryStreetNumber" matInput [formControlName]="'DeliveryStreetNumber'" placeholder="Street number" (keyup)="isFormValid()">
            <mat-error *ngIf="orderDeliveryDetailsForm.get('DeliveryStreetNumber').hasError('required')">
                Street Number is required
            </mat-error>
        </mat-form-field>

        <!-- Street number field -->
        <mat-form-field class="w-full">
            <mat-label>Street name</mat-label>
            <input id="DeliveryStreetName" matInput [formControlName]="'DeliveryStreetName'"
                placeholder="Street name" (keyup)="isFormValid()">
            <mat-error *ngIf="orderDeliveryDetailsForm.get('DeliveryStreetName').hasError('required')">
                Street name is required
            </mat-error>
        </mat-form-field>

    </form>
</div>

<div *ngIf="ResidenceType == 'Estate' || ResidenceType == 'Apartment' ">
    <form [formGroup]="orderDeliveryDetailsForm" #orderDeliveryDetailsNgForm="ngForm">

        <!-- Unit Number field -->
        <mat-form-field class="w-full">
            <mat-label>Unit number</mat-label>
            <input id="unitNumber" matInput [formControlName]="'DeliveryUnitNumber'" placeholder="Unit number" (keyup)="isFormValid()">
            <mat-error *ngIf="orderDeliveryDetailsForm.get('DeliveryUnitNumber').hasError('required')">
                Unit Number is required
            </mat-error>
        </mat-form-field>

        <!-- Complex name field -->
        <mat-form-field class="w-full">
            <mat-label>Estate/Complex name</mat-label>
            <input id="complexName" matInput [formControlName]="'DeliveryComplexName'"
                placeholder="Estate/Complex name" (keyup)="isFormValid()">
            <mat-error *ngIf="orderDeliveryDetailsForm.get('DeliveryComplexName').hasError('required')">
                Estate/Complex name is required
            </mat-error>
        </mat-form-field>

        <!-- Floor number field -->
        <mat-form-field class="w-full" *ngIf="ResidenceType == 'Apartment'">
            <mat-label>Floor number</mat-label>
            <input id="floorNumber" matInput [formControlName]="'DeliveryFloorNumber'" placeholder="Floor Number" (keyup)="isFormValid()">
        </mat-form-field>

        <!-- Block name field -->
        <mat-form-field class="w-full" *ngIf="ResidenceType == 'Apartment'">
            <mat-label>Block name</mat-label>
            <input id="blockName" matInput [formControlName]="'DeliveryBlockName'" placeholder="Block Name" (keyup)="isFormValid()">
        </mat-form-field>

        <!-- Complex street name field -->
        <mat-form-field class="w-full">
            <mat-label>Estate/Complex street name</mat-label>
            <input id="complexStreetName" matInput [formControlName]="'DeliveryComplexStreetName'"
                placeholder="Estate/Complex street name" (keyup)="isFormValid()">
            <mat-error *ngIf="orderDeliveryDetailsForm.get('DeliveryComplexStreetName').hasError('required')">
                Estate/Complex Street name is required
            </mat-error>
        </mat-form-field>

        <!-- Sub Complex name field -->
        <mat-form-field class="w-full">
            <mat-label>Sub-complex name</mat-label>
            <input id="subComplexName" matInput [formControlName]="'DeliverySubComplexName'"
                placeholder="Sub-complex name" (keyup)="isFormValid()">
            <mat-error *ngIf="orderDeliveryDetailsForm.get('DeliverySubComplexName').hasError('required')">
                Sub-complex name name is required
            </mat-error>
        </mat-form-field>
    </form>
</div>

<div *ngIf="ResidenceType == 'Plot'">
    <form [formGroup]="orderDeliveryDetailsForm" #orderDeliveryDetailsNgForm="ngForm">

        <!-- Plot Number field -->
        <mat-form-field class="w-full">
            <mat-label>Plot number</mat-label>
            <input id="plotNumber" matInput [formControlName]="'DeliveryErfNumber'" placeholder="Plot number" (keyup)="isFormValid()">
            <mat-error *ngIf="orderDeliveryDetailsForm.get('DeliveryErfNumber').hasError('required')">
                Plot Number is required
            </mat-error>
        </mat-form-field>

        <!-- Plot notes field -->
        <mat-form-field class="w-full">
            <mat-label>Notes</mat-label>
            <textarea id="leadNotes" matInput [formControlName]="'LeadNotes'"
                placeholder="Estate/Complex name" (keyup)="isFormValid()"> </textarea>
        </mat-form-field>
    </form>
</div>

<form [formGroup]="orderDeliveryDetailsForm" #orderDeliveryDetailsNgForm="ngForm">

    <!-- Town field -->
    <mat-form-field class="w-full">
        <mat-label>Town</mat-label>
        <input id="plotNumber" matInput [formControlName]="'DeliveryTown'" placeholder="Town" (keyup)="isFormValid()">
        <mat-error *ngIf="orderDeliveryDetailsForm.get('DeliveryTown').hasError('required')">
            Town is required
        </mat-error>
    </mat-form-field>

    <!-- Province field -->
    <mat-form-field class="w-full">
        <mat-label>Province</mat-label>
        <mat-select [formControlName]="'DeliveryCity'" (selectionChange)="isFormValid()">
          <mat-option *ngFor="let province of provinces" [value]="province">{{ province }}</mat-option>
        </mat-select>
    </mat-form-field>
      

    <!-- Postal Code field -->
    <mat-form-field class="w-full">
        <mat-label>Postal Code</mat-label>
        <input id="DeliveryPostalCode" matInput [formControlName]="'DeliveryPostalCode'"
            placeholder="Postal Code" (keyup)="isFormValid()">
    </mat-form-field>
</form>